import { useQueryClient } from '@tanstack/react-query'

export interface BlickPlusSkeleton {
  plusSharingLinkGenerationAmount: number
}

type UseBlickPlusSkeleton = () => BlickPlusSkeleton

const useBlickPlusSkeleton: UseBlickPlusSkeleton = () => {
  const queryClient = useQueryClient()

  return queryClient.getQueryData<BlickPlusSkeleton>([
    'blickPlusSkeleton',
  ]) as BlickPlusSkeleton
}

export default useBlickPlusSkeleton
